
import React, { useContext, useRef } from "react";
import TypeCheckContext from "Context/TypeCheckAndDataContext";
import { useNavigate } from "react-router-dom";

const AdvancedLink = (props) => {
  const { to, className, style, children, state, currentPageView, pageTypeCheck, pageName,breadcrumbFirstId, ...rest } = props;
  const { pathURL, setPathURL } = useContext(TypeCheckContext);
  const navigate = useNavigate()

  const uniqueIdRef = useRef(`link-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`);

  const callContext = (e) => {
    e.preventDefault();

    if (e.ctrlKey || e.metaKey) {
      window.open(to, "_blank");
      return;
    }

    if (to && pathURL !== to) {
      setPathURL({
        url: to,
        from: "",
        state,
        pageTypeCheck,
        uniqueId: uniqueIdRef.current,
        currentPageView,
        pageName,
        breadcrumbFirstId
      });

      if (pageTypeCheck === "plp_filter") {
        // Prevent scroll reset only for 'plp_filter'
        return;
      }
      if (state?.urlType?.entityType !== "product") {
        window.scrollTo(0, 0);
      }

      if (to === "/") {
        navigate(to);
      }

      if (to === "/blog") {
        navigate(to, { state });
      }


    }
  };

  const { onClick, ...filteredRest } = rest;

  // Combine the passed `onClick` with the `callContext` function
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
    callContext(e);
  };

  const getString = (val) => {
    if (typeof val === "string") return val;
    if (typeof val === "number") return String(val);
    return "";
  };

  return (
    <a
      href={to}
      onClick={handleClick}
      aria-label={
        getString(children?.props?.children) ||
        getString(children?.props?.children?.[0]) ||
        getString(children?.props?.alt) ||
        getString(children?.[0]?.props?.alt) ||
        getString(children?.props?.listItem?.names) ||
        getString(children?.props?.listItem?.name) ||
        getString(children)
      }
      className={className}
      style={style}
      {...filteredRest} >
      {children}
    </a >
  );
};

export default AdvancedLink;
